import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { ProviderTypeService } from '../../service/provider-type.service';
import { HttpBaseService } from '../../service/http-base.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BeyondEMRConstants } from '../../helpers/beyondemrconstants';
import * as moment from 'moment';

@Component({
  selector: 'app-custom-editor-dialog',
  templateUrl: './custom-editor-dialog.component.html',
  styleUrls: ['./custom-editor-dialog.component.sass']
})
export class CustomEditorDialogComponent implements OnInit {
  public enumName: string;
  public result: string;
  public editorType: string;
  public displayName: string;
  public masterData: any;
  public dropdownMaster: any;

  constructor(
    public dialogRef: MatDialogRef<CustomEditorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,    
    private httpService: HttpBaseService,
    private snackBar: MatSnackBar
  ) {
    dialogRef.disableClose = true;

    this.masterData = [{
      "person": [
        { key: "father", value: "father" },
        { key: "mother", value: "mother" },
        { key: "grand father", value: "grand father" },
        { key: "grand mother", value: "grand mother" }],
      "focus": [
        { key: "Speech Intelligibility", value: "Speech Intelligibility" },
        { key: "Expressive-Receptive Language", value: "Expressive-Receptive Language" },
        { key: "Cognitive-Linguistic skills", value: "Cognitive-Linguistic skills" },
        { key: "Social Pragmatic Language skills", value: "Social Pragmatic Language skills" }],
      "transition": [
        { key: "independently", value: "independently" },
        { key: "MinA", value: "given minimal assistant" },
        { key: "ModA", value: "given moderate assistance" },
        { key: "MaxA", value: "given maximum assistance" },
        { key: "Alert", value: "alert and cooperative" },
        { key: "Unalert", value: "not alert" },
        { key: "Uncooperative", value: "was uncooperative during treatment session" }]
    }]
  }

  ngOnInit() {
    this.enumName = this.data.enumName;
    this.editorType = this.enumName.split('_')[0];
    this.displayName = this.enumName.split('_')[1];
    this.bindMasterData();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  confirmChange(): void {
    if (this.editorType == 'percent') {
      this.result += '%';
    }
    else if (this.editorType == 'date') {
      this.result = moment(this.result).format('MM/DD/yyyy');
    }
    this.dialogRef.close(this.result);
  }

  bindMasterData() {
    if (this.editorType == 'drop') {
      this.dropdownMaster = this.masterData[0][this.displayName];
    }
  }
}
